import { Box, TextField, Tooltip } from '@mui/material';
import { useInput } from 'react-admin';

const normalize = (raw: string) => {
  if (raw === '#' || raw === '') { return ''; }
  const value = raw.replace(/[^a-f0-9]/gi, '').substring(0, 6);
  return value ? `#${value.toUpperCase()}` : '';
};

const isComplete = (value: string) => /^#([0-9a-f]{3}){1,2}$/i.test(value);

const validateHex = (value: string) =>
  value && !isComplete(value) ? 'Hex inválido' : undefined;

interface Props {
  source: string;
  label: string;
  disabled?: boolean;
  onFocus?: () => void;
}

/**
 * Input de cor ligado ao form do react-admin via `useInput`, para participar do
 * dirty/reset/validate do `<SimpleForm>` como qualquer outro input.
 */
const ColorInput = ({ source, label, disabled, onFocus }: Props) => {
  const { field, fieldState, isRequired } = useInput({ source, validate: validateHex });

  const current = field.value || '';
  const valid = isComplete(current);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: '1 1 200px', minWidth: 200 }}>
      <Tooltip title={valid ? 'Escolher no seletor' : 'Informe uma cor válida'}>
        <Box
          component="input"
          type="color"
          value={valid ? current : '#FFFFFF'}
          disabled={disabled}
          onChange={event => field.onChange((event.target as HTMLInputElement).value.toUpperCase())}
          sx={{
            width: 36, height: 36, padding: 0, border: '1px solid',
            borderColor: 'divider', borderRadius: 1,
            cursor: disabled ? 'default' : 'pointer', backgroundColor: 'transparent',
          }}
        />
      </Tooltip>
      <TextField
        name={field.name}
        label={label}
        value={current}
        disabled={disabled}
        required={isRequired}
        variant="standard"
        fullWidth
        onBlur={field.onBlur}
        onFocus={onFocus}
        onChange={event => field.onChange(normalize(event.target.value))}
        error={!!(fieldState.isTouched && fieldState.error)}
        helperText={fieldState.isTouched && fieldState.error ? fieldState.error.message : ' '}
        slotProps={{ formHelperText: { sx: { fontSize: 10, mt: 0 } } }}
      />
    </Box>
  );
};

export default ColorInput;
